export default {
  4: {
    brand: 'Audi',
    header: 'Brukte bildeler til Audi',
    body: `Kjøp brukte bildeler til Audi i vårt store utvalg av bildeler til både nye og eldre biler.<br/>
			Enten du er på utkikk etter motordeler, girdeler, karosseri eller interiør er sjansen stor for at du finner akkurat det du leter etter ved å bruke filteret nedenfor.<br/>
			Vi har et utvalg av bruktdeler til bl.a. Audi 80, Audi 90, Audi 100, Audi Quattro, Audi A3, Audi A4, Audi A6, Audi A8 for å nevne noen.<br/>`
  }
};
